<template>
  <div class="com-img-silder">
    <div class="img-box" :style="concept_img_style">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="img, index in img_list" :key="index">
          <div class="head-img" :style="img"></div>
        </div>
      </div>
    </div>
    <div class="progress-bar">
      <div class="progress-item" v-for="item, index in img_list" :key="index" :class="{'selected': index == curr_img}"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/swiper.min.css'
export default {
  props: {
    imgList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      img_list: [],
      concept_img_style: {},
      curr_img: 0,
    }
  },
  mounted () {
    this.img_list = this.imgList
      .filter(item => !!item)
      .slice(0,12)
      .map((item, index) => {
        return this.handleImageSize(item.width, item.height, item.url, index)
      })
    this.$nextTick(() => {
      this.initSwiper()
    })
  },
  methods: {
    handleImageSize (width, height, url, index) {
      const ratio = width / height
      const use_origin = width < 450 && height < 300
      const window_width = window.innerWidth > 640 ? 640 : window.innerWidth
      let result
      if (index == 0) {
        this.stable_ratio = use_origin
                              ? 1.666
                              : ratio > 1.666
                                ? 1.666
                                : ratio < 0.75 
                                  ? 0.75
                                  : ratio
        this.concept_img_style = {
          height: window_width * (1 / this.stable_ratio) + 'px'
        }
      }
      if (use_origin) {
        result = {
          background: `center center / auto auto url(${url}) no-repeat`
        }
      } else if (ratio >= this.stable_ratio) {
        result = {
          background: `center center / 100% auto url(${url}) no-repeat`
        }
      } else {
        result = {
          background: `center center / auto 100% url(${url}) no-repeat`
        }
      }
      return result
    },
    // 初始化swiper
    initSwiper () {
      this.swiper = new Swiper(".img-box", {
        direction: "horizontal",
        on: {
          slideChange: (swiper) => {
            this.curr_img = swiper.activeIndex
          }
        }
      })
    },
  },
}
</script>

<style lang="less">
.com-img-silder {
  width: 100% ;
  max-width: 640px;
  background: #FFFFFF;
  .img-box {
    width: 100%;
    overflow: hidden;
    .swiper-wrapper {
      .swiper-slide {
        .head-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  .progress-bar {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 12px 0 6px;
    .progress-item {
      height: 2px;
      width: 8px;
      border-radius: 1px;
      background: #DADDE0;
      &.selected {
        background: #14191E;
      }
      & + .progress-item {
        margin-left: 6px;
      }
    }
  }
}
</style>